import { render, staticRenderFns } from "./AdmissionProfileForm.vue?vue&type=template&id=60a915b0&scoped=true"
import script from "./AdmissionProfileForm.vue?vue&type=script&lang=js"
export * from "./AdmissionProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a915b0",
  null
  
)

export default component.exports